import { SourcesOfIncome } from '../components';
import { useSourcesOfIncome } from '../hooks';
import { PageComponentProps } from '../types';

export const SourcesOfIncomeStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    files,
    submitLoading,
    submitDisabled,
    onSubmit,
    onAddFiles,
    onRemoveFile,
    goToBack,
  } = useSourcesOfIncome();

  return (
    <SourcesOfIncome
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
